import { css } from '@microsoft/fast-element';
import { genericFormStyling } from '../../../../styles/common/form.styles';
import { mixinRobotoMedium } from '../../../../styles';

export const editStyles = css`
  ${genericFormStyling}

  :host {
    width: 1150px;
  }

  .form {
    display: flex;
    gap: 20px;
    margin-left: auto;
    margin-right: auto;
  }

  .form-header {
    font-size: 16px;
    color: var(--primary-color);
    font-weight: 500;
    padding-bottom: 20px;
    padding-top: 5px;
    ${mixinRobotoMedium()}
  }

  .form-control {
    display: flex;
    flex-direction: column;
  }

  .form-column {
    display: flex;
    flex-direction: column;
    width: 33%;
  }

  .left,
  .right {
    flex: 1;
  }

  .confirm-button {
    margin-top: 30px;
    float: right;
    margin-left: 10px;
  }

  .combobox {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .label {
    font-size: var(--type-ramp-base-font-size);
    margin: calc(var(--design-unit) * 2px) 0;
  }

  .company-details {
    height: 45px;
    padding: 0;
    font-size: 18px;
    font-weight: 700;
    color: var(--white);
    line-height: normal;
  }

  .form-session {
    height: 20px;
    margin: 8px 0;
    color: #879ba6;
    font-family: Roboto-Medium, sans-serif;
    font-style: normal;
    font-size: 13px;
    display: flex;
    align-items: center;
  }

  .form-session-elements {
    margin-bottom: 19px;
    display: flex;
    flex-direction: column;
  }

  .form-session-elements-horizontal {
    margin-bottom: 19px;
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  zero-text-field::part(label),
  zero-number-field::part(label) {
    padding-left: 0;
  }

  /* Vertical tabs */
  zero-tabs {
    grid-gap: 0 16px;
    min-height: 600px;
  }

  zero-tab-panel {
    background: #1a1e21;
    border: 1px solid var(--border-1);
    border-radius: 6px;
  }

  .vertical zero-tab {
    font-size: 13px;
    color: var(--nest-level-tab-font);
    width: 193px;
    background: transparent;
    border: none;
    box-shadow: none;
    justify-content: flex-start;
    border-left: 3px solid transparent;
    margin-right: 0;
  }

  .vertical zero-tab:hover {
    border-radius: 0;
    background: var(--button-hover-bg);
  }

  .vertical zero-tab-panel {
    padding: 16px 19px 16px 16px;
    height: 100%;
    overflow: auto;
  }

  .vertical zero-tab[aria-selected='true'] {
    color: var(--white);
    background: var(--button-hover-bg);
    border-color: var(--nested-level-tab-selected);
    border-radius: 0;
  }

  .vertical::part(tablist) {
    padding: 0px;
    grid-template-rows: 40px;
    height: 100%;
    background: #1a1e21;
    border: 1px solid var(--border-1);
    border-radius: 6px;
  }

  .vertical::part(end) {
    position: absolute;
    z-index: 2;
    top: 295px;
    height: auto;
    background: transparent;
    border: none;
    width: 170px;
  }

  .completed-tab-icon {
    padding-right: 8px;
    height: 16px;
  }

  .sef-group {
    display: flex;
    flex-direction: column;
    float: right;
  }

  .sef-group label {
    color: var(--font-color-1);
    margin-bottom: 8px;
    padding-left: 1px;
  }
`;
